// packages
import axios, { AxiosError, AxiosResponse } from 'axios'

// lib
import { AuthTokenError } from './errors/AuthTokenError'

// store
import { useAuthStore } from '@/store/auth'

// constants
import { HTTP_STATUS_CODE } from '@/constants/http'

function setupAPIClient() {
  const { token, logout } = useAuthStore.getState()

  const api = axios.create({
    baseURL: import.meta.env.VITE_API_URL
  })

  api.interceptors.request.use(
    config => {
      const storageToken = JSON.parse(localStorage.getItem(`${import.meta.env.VITE_APP_NAME}-auth-storage`) || '{}')?.state?.token
      if (token || storageToken) config.headers.Authorization = `Bearer ${token || storageToken}`
      return config
    },
    error => {
      if (error.response?.status === 504) {
        window.location.reload()
      }

      return Promise.reject(error)
    }
  )

  api.interceptors.response.use(
    response => {
      if ([403, 401].includes(response.data?.statusCode) && !window.location.href.includes('/login')) {
        logout()
      }
      return response
    },

    (error: AxiosError) => {
      if (error.response?.status === 401) {
        // qualquer erro 401 (não autorizado) desloga o usuário
        if (typeof window !== 'undefined') {
          // chama a função para deslogar o usuário
        } else {
          return Promise.reject(new AuthTokenError())
        }
      }

      // --- Nenhuma resposta chegou (Network Error / CORS / Timeout) ---
      if (error.code === 'ERR_NETWORK' || !error.response) {
        const simulatedResponse = {
          status: HTTP_STATUS_CODE.GATEWAY_TIMEOUT,
          statusText: 'Gateway Timeout (simulado pelo cliente)',
          data: {
            statusCode: HTTP_STATUS_CODE.GATEWAY_TIMEOUT,
            success: false,
            message: 'O servidor não respondeu (erro de rede ou CORS).'
          },
          headers: {},
          config: error.config
        }

        return Promise.resolve(simulatedResponse as AxiosResponse)
      }

      return Promise.reject(error)
    }
  )

  return api
}

export const api = setupAPIClient()
